import { PaginationRequest } from './api';
import { Map } from './universal';

export interface Hentai {
	hentaiUUID?: string;
	coverImageURL: string;
	title: string;
	description: string;
	link: string;
	categories: string[];
	studio: string;
	status: HentaiStatus;
	episode: Map<Episode>;
	isFavorite?: boolean;
	note: string;
	createdAt?: Date;
	updatedAt?: Date;
}

export interface Episode {
	link: string;
	createdAt?: Date;
}

export interface HentaiOption {
	categories: string[];
}

export interface HentaiPaginationRequest extends PaginationRequest {
	search?: string;
	categories?: string;
	status?: HentaiStatus;
	studio?: string;
	isFavorite?: boolean;
}

export enum HentaiStatus {
	OnGoing = 'ongoing',
	Completed = 'completed'
}

export interface HentaiDetail {
	coverImageURL: string;
	title: string;
	description: string;
	categories: string[];
	status: HentaiStatus;
	studio: string;
	link: string;
}
